module.exports = __webpack_public_path__ + "media/images/social-bccdeb9aa7444552b439c62ca3162e7e.jpg";